export default "__VITE_ASSET__5b991557__"